var lists_default = {
  "fontElementMap": "h6vCU",
  "orderedlist": "OZi00",
  "bulletedlist": "x11aw",
  "listItem": "E95nn"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
